import { UserType } from '@/store/slices/stagesSlice/interfaces'

export const getAdditionalFields = (user: UserType | null) => {
  const passportKey = ['passport_date', 'passport_number', 'passport_who_gave'];
  const additional_fields = [];
  const passport_data = [];

  if (user) {
    for (const key in user) {
      if (key !== 'permissions' && user[key as keyof UserType]) {
        let value = user[key as keyof UserType];

        if (passportKey.includes(key)) {
          if (key === 'passport_date' && value) {
            const [day, month, year] = (value as string).split('/');
            value = `${year}-${month}-${day}`;
          }
          passport_data.push({
            key,
            value,
          });
        } else {
          if (key === 'has_young_children') {
            // TODO: исключить @ts-ignore
            // @ts-ignore
            value = (value === 'yes');
          }

          if (key === 'birthday' && typeof value === 'string') {
            const [day, month, year] = value.split('/');
            value = `${year}-${month}-${day}`;
          }

          additional_fields.push({
            key,
            value,
          });
        }
      }
    }

    if (passport_data.length) {
      additional_fields.push({
        key: 'passport_data',
        value: passport_data,
      });
    }
  }

  return additional_fields;
};
